module.exports = __webpack_public_path__ + "img/img23.911df0e1.svg";